import { render, staticRenderFns } from "./OnboardingScheduleContribution.vue?vue&type=template&id=5545ff72"
import script from "./OnboardingScheduleContribution.vue?vue&type=script&lang=ts"
export * from "./OnboardingScheduleContribution.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports